import { MapTo } from '@adobe/aem-react-editable-components';
import NotificationBox, { NotificationBoxProps } from './NotificationBox';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';

const RESOURCE_TYPE = 'learning-academy/components/custom/notificationbox';

const NotificationBoxEmptyFn = (props: NotificationBoxProps) => !props || props.notifications === undefined;

const EditConfig = {
  emptyLabel: 'Notification Box',
  isEmpty: NotificationBoxEmptyFn,
};

export default MapTo<NotificationBoxProps>(RESOURCE_TYPE)(...WithEmptyPlaceholder(NotificationBox, EditConfig));
